import React from 'react';
interface ButtonProps {
  children: React.ReactNode;
  type?: 'button' | 'submit' | 'reset';
  variant?: 'primary' | 'outline' | 'text';
  fullWidth?: boolean;
  onClick?: () => void;
  disabled?: boolean;
}
export const Button = ({
  children,
  type = 'button',
  variant = 'primary',
  fullWidth = false,
  onClick,
  disabled = false
}: ButtonProps) => {
  const baseClasses = 'px-4 py-2 rounded-md font-medium transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2';
  const variantClasses = {
    primary: 'bg-primary-500 text-white hover:bg-primary-600 focus:ring-primary-500',
    outline: 'border border-primary-500 text-primary-500 hover:bg-primary-50 focus:ring-primary-500',
    text: 'text-primary-500 hover:text-primary-600 hover:bg-primary-50 focus:ring-primary-500'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button type={type} className={`${baseClasses} ${variantClasses[variant]} ${widthClass} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`} onClick={onClick} disabled={disabled} data-id="element-23">
      {children}
    </button>;
};